import React, { useState } from "react";
import { httpReauest } from "../../utils/httpRequest";
import SearchIcon from "../../icons/SearchIcon";
import { Link } from "react-router-dom";
import BlogsMobile from "../../components/common/mobile/BlogsMobile";
import RequestTalkModal from "../../components/common/mobile/RequestTalkModal";
import BlogsVideo from "../../components/common/mobile/BlogsVideo";
import BlogsImg from "../../components/common/mobile/BlogsImg";
import { Helmet } from "react-helmet";
import { toEnglishDigits } from "../../components/common/mobile/ProductsMobile";
import { useRouteInfo } from "../../hooks/useRouteInfo";

const BlogsMobilePage = () => {
  const [loading, setLoading] = useState();
  const [show, setShow] = useState();

  const [blogs, setBlogs] = useState();
  const [category, setcategory] = useState();
  const [text, settext] = useState();
  const [selected, setselected] = useState("مقالات");

  async function handleChange(e) {
    settext(toEnglishDigits(e.target.value));
  }

  const { metaData } = useRouteInfo();

  return (
    <div className="pt-2">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaData?.meta_title}</title>
        <meta name="description" content={metaData?.meta_desc} />
        <meta name="og:description" content={metaData?.meta_desc} />
        <meta name="og:title" content={metaData?.meta_title} />
        <link rel="canonical" href={metaData?.canonical} />
        <meta property="og:type" content={metaData?.meta_type} />
      </Helmet>{" "}
      {show && <RequestTalkModal setShow={setShow} />}{" "}
      <h1 className="title-mobile text-center mb-4">{metaData?.h1}</h1>
      <span className="relative w-full ">
        <input
          className="w-full form-brand px_se xl:min-w-[210px] h-[58px]"
          placeholder="جستجو"
          id="search_key"
          name="search_key"
          onChange={handleChange}
        />
        <img
          src="/Filter.png"
          alt="filter"
          className="absolute translate-y-[-50%] top-[50%] left-4"
        />
        <span className="absolute translate-y-[-50%] top-[50%] right-4">
          <SearchIcon />
        </span>
      </span>
      <div className="w-full flex gap-3 py-3 overflow-x-scroll border-b border-dashed border-[#8E9192] text-[14px]">
        <span
          onClick={() =>
            "مقالات" === selected ? setselected("") : setselected("مقالات")
          }
          className={`${
            selected === "مقالات" ? "bg-black text-white" : ""
          } border-brand-2 px-3 py-2 whitespace-nowrap font-bold`}
        >
          {"مقالات"}
        </span>
        <span
          onClick={() =>
            "ویدیو ها" === selected ? setselected("") : setselected("ویدیو ها")
          }
          className={`${
            selected === "ویدیو ها" ? "bg-black text-white" : ""
          } border-brand-2 px-3 py-2 whitespace-nowrap font-bold`}
        >
          {"ویدیو ها"}
        </span>
        <span
          onClick={() =>
            "گالری تصاویر" === selected
              ? setselected("")
              : setselected("گالری تصاویر")
          }
          className={`${
            selected === "گالری تصاویر" ? "bg-black text-white" : ""
          } border-brand-2 px-3 py-2 whitespace-nowrap font-bold`}
        >
          {"گالری تصاویر"}
        </span>
      </div>
      <div className="grid grid-cols-6 grid-rows-subgrid py-2 gap-1">
        {selected == "مقالات" ? (
          <BlogsMobile text={text} />
        ) : selected == "ویدیو ها" ? (
          <BlogsVideo />
        ) : (
          <BlogsImg />
        )}
      </div>
    </div>
  );
};

export default BlogsMobilePage;
